var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"unitselect"},_vm._l((_vm.units),function(xx,index){return _c('Checkbox',{key:index,on:{"on-change":function($event){return _vm.unitChange(xx, index)}},model:{value:(xx.select),callback:function ($$v) {_vm.$set(xx, "select", $$v)},expression:"xx.select"}},[_vm._v(_vm._s(xx.name))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0106b664","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wuliu/kehu/baojia/unitBoxDanjia.vue
// module id = null
// module chunks = 